(function(){
    angular
        .module('appback')
        .directive('ngUranotest', uranotest);

        uranotest.$inject = ['$http','$timeout','ResultadosService'];
        function uranotest($http,$timeout,ResultadosService){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=uranotest.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  //sub: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : {  images : {} }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { images : {} }};
				            }else{
				            	if(!scope.item.resultado.extra.resultado){
				            		scope.item.resultado.extra.resultado = { images : {} };
					            }else{
					            	if(Array.isArray(scope.item.resultado.extra.resultado)){
				            			scope.item.resultado.extra.resultado = { images : {} };
					            	}
				       				//console.log("resmd");
				       				//console.log(scope.item.resultado.extra.resultado);

					            }
				            }
				        }

						scope.$watch('item.resultado.extra.resultado.images', function(newVal, oldVal) {
							if (newVal !== oldVal) {
							  	console.log('La variable "images" ha cambiado:', newVal);
							  	ResultadosService.getSmartreader(newVal.fotos[newVal.fotos.length-1].image,function(data){
									if(data.result.iaValues.length==1){
										switch(data.result.iaValues[0].valueFin){
											case "Positive":
                                                scope.item.resultado.resultado = "1";
                                                break;
                                            case "Negative":
                                                scope.item.resultado.resultado = "0";
                                                break;
											case "Doubtful":
                                                scope.item.resultado.resultado = "3";
												break;
                                        }
										scope.item.resultado.extra.infoDetect = data.result.iaValues[0];
									}
									console.log("datasmart",data);
								});
							}
						  }, true);

			        });
		        }
          }
      }
})();